import { apiClient } from '../services/api-client';

/**
 * POSTs to a care-hooks endpoint.
 *
 * `TResponse` defaults to `unknown` as in `SendGridPoster`: every call site is
 * `/hooks/patient/status` followed by `.finally()`, which cannot observe the value.
 */
const HooksPoster = async <TResponse = unknown>(
  endPoint: string,
  token: string,
  data: unknown,
): Promise<TResponse> => {
  const result = await apiClient.post<TResponse>(
    import.meta.env.VITE_CARE_HOOKS_API_NAME,
    endPoint,
    {
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      },
      body: data,
    },
  );
  return result;
};

export default HooksPoster;
